import styled from "styled-components"
import { motion } from "framer-motion"

//Banner
export const Banner = styled.div`
  background: ${props => props.theme.background};
  height: 100vh;
  width: 100%;
  position: relative;
  margin-bottom: 296px;
  @media (max-width: 600px) {
    height: 70vh;
    margin-bottom: 120px;
  }
`
export const Video = styled.div`
  height: 100%;
  width: 100%;
  video {
    object-fit: cover;
  }
`
export const Canvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: block;
`

export const BannerTitle = styled(motion.h1)`
  position: absolute;
  bottom: -120px;
  left: -18px;
  color: ${props => props.theme.text};
  pointer-events: none;
  @media (max-width: 600px) {
    bottom: -48px;
    left: 0;
  }
`

export const Headline = styled(motion.span)`
  display: block;
  font-size: clamp(6rem, 25vw, 23rem);
  font-weight: 900;
  line-height: 0.76;
  @media (max-width: 600px) {
    font-size: clamp(3.5rem, 22vw, 6rem);
  }
`

//Content Section
export const HomeContentSection = styled(motion.div)`
  margin-bottom: 200px;
  @media (max-width: 600px) {
    margin-bottom: 100px;
  }
`
export const Content = styled(motion.h2)`
  width: 53%;
  font-size: 2.3rem;
  font-weight: 400;
  margin-left: 124px;
  color: ${props => props.theme.text};
  @media (max-width: 600px) {
    width: 100%;
    font-size: 1.5rem;
    margin-left: 0;
  }
`

//Featured Section
export const HomeFeaturedSection = styled(motion.div)`
  margin-bottom: 200px;
  position: relative;
  a {
    margin-bottom: 200px;
    position: relative;
    display: block;
  }
  @media (max-width: 600px) {
    margin-bottom: 100px;
    a {
      margin-bottom: 120px;
    }
  }
`

export const FeaturedContent = styled(motion.div)`
  height: 480px;
  width: 100%;
  padding: 56px 124px;
  box-sizing: border-box;
  color: ${props => props.theme.text};
  h3 {
    font-size: 1.4rem;
  }
  .meta {
    display: flex;
    h4 {
      &:last-child {
        margin-left: 1rem;
      }
    }
  }
  .featured-title {
    position: absolute;
    bottom: -128px;
    font-size: 7rem;
    font-weight: 900;
    line-height: 90px;
    margin: 0;
    .arrow {
      width: 120px;
      height: 80px;
      display: block;
      position: relative;
      overflow: hidden;
      svg {
        position: absolute;
        top: 16px;
        left: -48px;
        width: 108px;
        path {
          fill: ${props => props.theme.text};
        }
      }
    }
  }
  @media (max-width: 600px) {
    height: 280px;
    padding: 32px 24px;
    h3 {
      font-size: 1.2rem;
    }
    .featured-title {
      bottom: -56px;
      font-size: 2.6rem;
      line-height: 40px;
      .arrow {
        width: 56px;
        height: 38px;
        svg {
          top: 8px;
          left: -22px;
          width: 50px;
        }
      }
    }
  }
`

export const FeaturedVideo = styled.div`
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 480px;
  top: 0;
  display: block;
  overflow: hidden;
  @media (max-width: 600px) {
    height: 280px;
  }
`

export const FeaturedProjects = styled.div`
  margin-top: 200px;
  @media (max-width: 600px) {
    margin-top: 100px;
  }
  button {
    background: #ea281e;
    color: #fff;
    position: relative;
    padding: 20px;
    display: block;
    text-align: left;
    font-size: 1.4rem;
    line-height: 1;
    font-weight: 600;
    border: none;
    span {
      margin-right: 108px;
      display: block;
    }
    @media (max-width: 600px) {
      font-size: 1.1rem;
      span {
        margin-right: 64px;
      }
    }
    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      right: 20px;
      width: 35px;
      height: 7px;
      display: block;
      background: #fff;
      transform: translateY(-50%);
    }
    &:before {
      margin-top: -8px;
    }
    &:after {
      margin-top: 8px;
    }
  }
`

//ABOUT SECTION

export const HomeAboutSection = styled(motion.div)`
  /* margin-bottom: 200px; */
`
export const About = styled.div`
  width: 100%;
  h2 {
    width: 60%;
    font-size: 2.3rem;
    font-weight: 400;
    margin-left: 124px;
    color: ${props => props.theme.text};
  }
  p {
    max-width: 440px;
    font-size: 1rem;
    line-height: 1.6rem;
    margin-left: 124px;
    color: ${props => props.theme.text};
  }
  @media (max-width: 600px) {
    h2 {
      width: 100%;
      font-size: 1.5rem;
      margin-left: 0;
    }
    p {
      margin-left: 0;
    }
  }
`
export const Services = styled.div``

//Accordion

export const AccordionHeader = styled(motion.div)`
  width: 100%;
  color: #ea281e;
  height: 32px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 1.15rem;
  margin: 8px 0;
`
export const AccordionIcon = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 8px;
  span {
    width: 16px;
    height: 4px;
    background: #ea281e;
    transition: all 0.1s ease-in-out;
  }
`

export const AccordionContent = styled(motion.div)`
  overflow: hidden;
  padding-left: 40px;
  span {
    width: 100%;
    margin: 8px 0;
    font-size: 0.875rem;
    color: #ea281e;
    display: block;
    font-weight: 300;
  }
`
